import axios, { getData } from 'lib/axios'

export const getCompanyDetails = async (data) => {
  return axios.get('/company-details', data).then(getData)
}

export const postBasicCompanyDetails = async (data) => {
  return axios.post('/company-details/basic', data).then(getData)
}

export const postBankCompanyDetails = async (data) => {
  return axios.post('/company-details/bank', data).then(getData)
}

export const toggleJobBoardActivation = async (data) => {
  return axios.put('job-board-activation', data).then(getData)
}

export const firstTimeGenerateLink = async (data) => {
  return axios.put('activate-job-board', data).then(getData)
}
